import React from 'react';
import { SortOption } from 'src/features/types/r2fTypes';

interface R2FTableHeaderProps {
    sorting: SortOption;
    onSortChange: (newSorting: SortOption) => void;
    userCanEdit?: boolean;
}

/**
 * Table header component with sorting capabilities for R2F threshold table
 */
export const R2FTableHeader: React.FC<R2FTableHeaderProps> = ({
    sorting,
    onSortChange,
    userCanEdit = false
}) => {
    return (
        <thead>
            <tr>
                {/* Empty header for expand/collapse column */}
                <th className="expand-header-col"></th>
                
                <th 
                    className={`sortable-header ${sorting.field === 'productionCapability' ? `sorted-${sorting.direction}` : ''}`}
                    onClick={() => onSortChange({
                        field: 'productionCapability', 
                        direction: sorting.field === 'productionCapability' && sorting.direction === 'asc' ? 'desc' : 'asc'
                    })}
                >
                    Production Capability
                </th>
                
                <th 
                    className={`sortable-header ${sorting.field === 'handlingTier' ? `sorted-${sorting.direction}` : ''}`}
                    onClick={() => onSortChange({
                        field: 'handlingTier',
                        direction: sorting.field === 'handlingTier' && sorting.direction === 'asc' ? 'desc' : 'asc'
                    })}
                >
                    Handling Tier
                </th>
                
                <th 
                    className={`sortable-header ${sorting.field === 'lowThreshold' ? `sorted-${sorting.direction}` : ''}`}
                    onClick={() => onSortChange({
                        field: 'lowThreshold', 
                        direction: sorting.field === 'lowThreshold' && sorting.direction === 'asc' ? 'desc' : 'asc'
                    })}
                >
                    Low Threshold (%)
                </th>
                
                <th 
                    className={`sortable-header ${sorting.field === 'highThreshold' ? `sorted-${sorting.direction}` : ''}`}
                    onClick={() => onSortChange({
                        field: 'highThreshold', 
                        direction: sorting.field === 'highThreshold' && sorting.direction === 'asc' ? 'desc' : 'asc'
                    })}
                >
                    High Threshold (%)
                </th>
                
                <th 
                    className={`sortable-header ${sorting.field === 'lastUpdated' ? `sorted-${sorting.direction}` : ''}`}
                    onClick={() => onSortChange({
                        field: 'lastUpdated', 
                        direction: sorting.field === 'lastUpdated' && sorting.direction === 'asc' ? 'desc' : 'asc'
                    })}
                >
                    Last Updated
                </th>
                
                {/* User column */}
                <th>User</th>
                
                {/* Actions column, only if userCanEdit */}
                {userCanEdit && <th className="actions-header">Actions</th>}
            </tr>
        </thead>
    );
};
